// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kY1uf","left":"styles_left__2b8tA"};